import React, { useCallback } from 'react';
import { SourceStoneKey } from '../../types';
import SourceItem from './items/SourceItem';

interface SourcePanelProps {
  metastones: Record<string, Record<string, string>>;
  metastoneOptions: Record<SourceStoneKey, 'A' | 'B'>;
  toggleMetastone: (stone: SourceStoneKey) => void;
}

const SourcePanel: React.FC<SourcePanelProps> = ({
  metastones,
  metastoneOptions,
  toggleMetastone
}) => {
  const stones = React.useMemo(() => Object.keys(metastones || {}) as SourceStoneKey[], [metastones]);

  return (
    <>
      {stones.map(stone => (
        <SourceItem
          key={stone}
          stone={stone}
          text={metastones?.[stone]?.[metastoneOptions?.[stone]] || 'No data'}
          toggleMetastone={toggleMetastone}
        />
      ))}
    </>
  );
};

export default SourcePanel;
